import script from "./SpeV2PendingCapa.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2PendingCapa.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2PendingCapa.vue?vue&type=style&index=0&id=222ca2cd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222ca2cd"]])

export default __exports__